import { createQueryParams } from '@/utils/query-params';
import { api } from './index';

const BASE_PATH = '/api/internal/shift_offerings';

export type ShiftOfferingResponse = {
  id: number;
  caregiverId: number;
  caregiverFullName: string;
  caregiverCareer: string;
  caregiverHumanCareer: string;
  aasmState: string;
  respondedAt: string | null;
  shiftId: number | null;
};

export type ShiftOffering = {
  id: number;
  patientId: number;
  patientFullName: string;
  shiftId: number | null;
  aasmState: string;
  startDatetime: string;
  endDatetime: string;
  humanDate: string;
  humanTime: string;
  slots: number;
  acceptedCount: number;
  slotsRemaining: number;
  expiresAt: string;
  replacement: boolean;
  createdAt: string;
  shiftOfferingResponses: ShiftOfferingResponse[];
};

export interface ShiftOfferingCreateForm {
  patientId: number;
  shiftId?: number;
  startDatetime: string;
  endDatetime: string;
  slots: number;
  caregiverIds: number[];
}

export const shiftOfferingsApi = {
  index(params?: { patientId?: number; aasmState?: string }): Promise<Array<ShiftOffering>> {
    const queryString = params ? createQueryParams(params) : '';

    return api({
      method: 'get',
      url: queryString ? `${BASE_PATH}?${queryString}` : BASE_PATH,
    }).then(response => response.data.shiftOfferings);
  },
  create(form: ShiftOfferingCreateForm): Promise<ShiftOffering> {
    return api({
      method: 'post',
      url: BASE_PATH,
      data: { shiftOffering: form },
    }).then(response => response.data.shiftOffering);
  },
  update(id: number, params: Partial<ShiftOffering>): Promise<ShiftOffering> {
    return api({
      method: 'patch',
      url: `${BASE_PATH}/${id}`,
      data: { shiftOffering: params },
    }).then(response => response.data?.shiftOffering);
  },
};
